<template>
    <div class="menu-list">
        <div v-for="(item, index) in state.list" :key="index">
            <div class="father-box" @click="changeShow(index)">
                <span :class="['icons', item.icon_type]"></span>
                {{ item.title }}
                <span :class="['icon-arrowup icons icons-right', {'rotated': item.show}]"></span>
            </div>
            <el-collapse-transition>
                <div v-show="item.show && item.son_info && item.son_info.length">
                    <div
                        :class="['son-box', { 'active': item.fater_id == props.fater_id && sitem.son_id == props.son_id }]" 
                        v-for="(sitem, sindex) in item.son_info" 
                        :key="sindex"
                        @click="changeProtocal(item, sitem)">
                        {{ sitem.son_title }}
                    </div>
                </div>
            </el-collapse-transition>
        </div>
    </div>
</template>

<script setup>
import { getprotocalList } from "@/api/index"

import { defineProps, reactive, onMounted, defineEmits } from "vue"
import { useRouter } from "vue-router";

const router = useRouter()

const props = defineProps(['son_id', 'fater_id'])

const state = reactive({
    list: []
})

onMounted(() => {
    getList()
})

const getList = () => {
    getprotocalList().then(res=> {
        if(res.status == 0) {
            state.list = res.data
            
            // 为"条款"分类（fater_id: 3）添加"立规公示"项目
            state.list.map(item => {
                if (item.fater_id == props.fater_id) {
                    item.show = true
                }
                
                // 在条款分类下添加立规公示
                if (item.fater_id == 3 && item.title == '条款') {
                    const liguiGongshi = {
                        id: 999, // 使用一个不会冲突的ID
                        son_id: 99, // 使用一个不会冲突的son_id
                        son_title: "立规公示",
                        son_list_num: 0,
                        link: "", // 空链接，跳转到本地页面
                        if_show: true,
                        son_if_show: true
                    }
                    // 在son_info数组末尾添加立规公示
                    item.son_info.push(liguiGongshi)
                }
            })
        }
    })
}

const changeShow = (index) => {
    state.list[index].show = !state.list[index].show
}

const emit = defineEmits(['getDetail']);
const changeProtocal = (item, sitem) => {
    console.log(sitem)
    if(sitem.link) {
        window.open(sitem.link)
    } else {
        // 特殊处理立规公示：跳转到 rule.vue 页面
        if (sitem.son_title === '立规公示' || sitem.son_id == 99) {
            router.push(`/protocal/rule/${item.fater_id}/${sitem.son_id}`)
        } else {
            router.push(`/protocal/${item.fater_id}/${sitem.son_id}`)
        }
        emit('getDetail', { fater_id: item.fater_id, son_id: sitem.son_id })
    }
}

</script>

<style lang="scss" scoped>
.menu-list {
    width: 240px;
    user-select: none;
    margin: 0 40px 0;
    padding: 30px 10px;
    background-color: #F8F8F8;
    border-radius: 8px;
    font-family: PingFang SC-Light, PingFang SC;
}
.father-box {
    font-size: 16px;
    font-weight: 500;
    padding: 20px 0 0 36px;
    position: relative;
    margin-bottom: 12px;
    cursor: pointer;
    .icons {
        position: absolute;
        left: 10px;
        top: 22px;
        transition: transform 0.3s;
        &.icons-right {
            left: auto;
            right: 10px;
        }
        &.rotated {
            transform: rotate(180deg);
        }
    }
}
.son-box {
    cursor: pointer;
    line-height: 22px;
    padding: 5px 0 5px 26px;
    font-size: 14px;
    &:hover, &.active {
        background-color: #E8E8E8;
        font-weight: bold;
        border-radius: 4px;
    }
}
</style>
